export default "__VITE_PUBLIC_ASSET__5285207f__"